module.exports = {"name":"DiscussionsHighlightPosts","parameters":[{"name":"DiscussionsHighlightPostsEnabled","value":false}]}